module.exports = __webpack_public_path__ + "6e765fe4f54cdcc21551ed2a019a96c8.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-320.webp
// module id = 411
// module chunks = 0